/**
 * @fileoverview Device detection (mobile vs desktop) via user agent.
 * Used by flow packages to adapt UI and analytics (e.g. Pulse platform).
 */

const isMobile = {
	Android: function () {
		return navigator.userAgent.match(/Android/i);
	},
	BlackBerry: function () {
		return navigator.userAgent.match(/BlackBerry/i);
	},
	iOS: function () {
		return navigator.userAgent.match(/iPhone|iPad|iPod/i);
	},
	Opera: function () {
		return navigator.userAgent.match(/Opera Mini/i);
	},
	Windows: function () {
		return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
	},
	any: function () {
		return (
			isMobile.Android() ||
			isMobile.BlackBerry() ||
			isMobile.iOS() ||
			isMobile.Opera() ||
			isMobile.Windows()
		);
	}
};

/**
 * Device type helper exposed to flow packages.
 */
export const DeviceHelper = {
	/**
	 * Returns 'Mobile' or 'Desktop' based on user agent.
	 * @returns {'Mobile'|'Desktop'}
	 */
	identify: () => {
		return isMobile.any() ? 'Mobile' : 'Desktop';
	}
};
